import styled from 'styled-components';
import { Subtitle as DefaultSubtitle, Text } from '~components';

export const Container = styled.section`
  margin-top: ${({ theme }) => theme.spacing.km10};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const Content = styled.section``;

export const Subtitle = styled(DefaultSubtitle)`
  margin-top: ${({ theme }) => theme.spacing.km2};
  margin-bottom: ${({ theme }) => theme.spacing.km6};

  font-size: ${({ theme }) => theme.font.size.m5};
  font-weight: ${({ theme }) => theme.font.weight.bold};
`;

export const Description = styled(Text)`
  display: block;
  letter-spacing: -0.03em;
  margin-bottom: ${({ theme }) => theme.spacing.km6};
`;
